var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaught(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 127.314 127.314",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 127.314 127.314"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff1a1a"
    },
    cx: 32.237,
    cy: 90.36,
    r: 30.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d60909"
    },
    cx: 32.237,
    cy: 90.36,
    rx: 30.737,
    ry: 23.543
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1.5,90.36c0,16.978,13.761,30.737,30.737,30.737c16.975,0,30.736-13.76,30.736-30.737H1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M32.237,113.903c16.975,0,30.736-10.541,30.736-23.543H1.5 C1.5,103.362,15.261,113.903,32.237,113.903z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M32.237,58.124C14.461,58.124,0,72.584,0,90.36c0,17.776,14.461,32.237,32.237,32.237 s32.236-14.461,32.236-32.237C64.473,72.584,50.012,58.124,32.237,58.124z M32.237,61.124c15.618,0,28.415,12.31,29.198,27.736 H3.038C3.821,73.433,16.619,61.124,32.237,61.124z M32.237,119.597c-15.618,0-28.415-12.31-29.199-27.737h58.397 C60.652,107.287,47.855,119.597,32.237,119.597z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a7bbc1"
    },
    cx: 32.237,
    cy: 93.438,
    r: 9.308
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 32.237,
    cy: 90.272,
    r: 9.308
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M25.655,96.854c-3.635-3.634-3.635-9.527,0-13.164c3.635-3.633,9.528-3.633,13.163,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M32.237,101.08c-2.887,0-5.601-1.124-7.642-3.166c-2.042-2.041-3.166-4.754-3.166-7.642 c0-2.887,1.125-5.601,3.166-7.644c4.215-4.212,11.07-4.211,15.284,0c0,0,0,0,0,0c2.042,2.042,3.166,4.757,3.166,7.644 c0,2.887-1.125,5.601-3.166,7.642C37.837,99.956,35.124,101.08,32.237,101.08z M32.237,82.469c-2,0-3.999,0.761-5.521,2.282 c-1.475,1.475-2.287,3.437-2.287,5.522s0.813,4.046,2.287,5.52c1.475,1.475,3.436,2.287,5.521,2.287s4.046-0.812,5.521-2.287 c1.475-1.475,2.287-3.435,2.287-5.521s-0.812-4.047-2.287-5.522C36.236,83.229,34.236,82.469,32.237,82.469z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff1a1a"
    },
    cx: 62.973,
    cy: 36.955,
    r: 30.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d60909"
    },
    cx: 62.973,
    cy: 36.955,
    rx: 30.737,
    ry: 23.542
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M32.237,36.955c0,16.977,13.761,30.737,30.737,30.737c16.975,0,30.736-13.76,30.736-30.737H32.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M62.974,60.497c16.975,0,30.736-10.541,30.736-23.542H32.237 C32.237,49.956,45.998,60.497,62.974,60.497z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M62.974,4.717c-17.775,0-32.237,14.461-32.237,32.237s14.461,32.237,32.237,32.237 S95.21,54.73,95.21,36.955S80.749,4.717,62.974,4.717z M62.974,7.717c15.618,0,28.415,12.31,29.198,27.737H33.775 C34.558,20.027,47.356,7.717,62.974,7.717z M62.974,66.192c-15.618,0-28.415-12.31-29.199-27.737h58.397 C91.388,53.882,78.592,66.192,62.974,66.192z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a7bbc1"
    },
    cx: 62.973,
    cy: 40.033,
    r: 9.309
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 62.973,
    cy: 36.867,
    r: 9.308
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M56.392,43.449c-3.635-3.635-3.635-9.528,0-13.163c3.635-3.635,9.528-3.635,13.163,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M62.974,47.675c-2.887,0-5.601-1.124-7.642-3.166c-2.042-2.041-3.166-4.755-3.166-7.642 s1.125-5.601,3.166-7.642c2.041-2.042,4.755-3.166,7.642-3.166s5.601,1.124,7.642,3.165l0,0c0,0,0,0,0,0 c2.042,2.041,3.166,4.755,3.166,7.642c0,2.887-1.124,5.601-3.166,7.643C68.574,46.551,65.86,47.675,62.974,47.675z M62.974,29.06 c-2.085,0-4.046,0.812-5.521,2.287s-2.287,3.436-2.287,5.521s0.813,4.046,2.287,5.521s3.436,2.287,5.521,2.287 s4.046-0.812,5.521-2.287c1.475-1.475,2.287-3.436,2.287-5.521s-0.812-4.046-2.287-5.521c0,0,0,0,0,0 C67.02,29.872,65.059,29.06,62.974,29.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff1a1a"
    },
    cx: 95.078,
    cy: 90.36,
    r: 30.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d60909"
    },
    cx: 95.078,
    cy: 90.36,
    rx: 30.737,
    ry: 23.543
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M64.341,90.36c0,16.978,13.761,30.737,30.737,30.737c16.975,0,30.736-13.76,30.736-30.737H64.341z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M95.078,113.903c16.975,0,30.736-10.541,30.736-23.543H64.341 C64.341,103.362,78.103,113.903,95.078,113.903z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M95.078,58.124c-17.775,0-32.237,14.461-32.237,32.236c0,17.776,14.461,32.237,32.237,32.237 s32.236-14.461,32.236-32.237C127.314,72.584,112.854,58.124,95.078,58.124z M95.078,61.124c15.618,0,28.415,12.31,29.198,27.736 H65.879C66.663,73.433,79.46,61.124,95.078,61.124z M95.078,119.597c-15.618,0-28.415-12.31-29.199-27.737h58.397 C123.493,107.287,110.696,119.597,95.078,119.597z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a7bbc1"
    },
    cx: 95.078,
    cy: 93.438,
    r: 9.308
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 95.078,
    cy: 90.272,
    r: 9.308
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M88.497,96.854c-3.635-3.634-3.635-9.527,0-13.164c3.635-3.633,9.528-3.633,13.163,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M95.078,101.08c-2.887,0-5.601-1.124-7.642-3.166c-2.042-2.041-3.166-4.754-3.166-7.642 c0-2.887,1.125-5.601,3.166-7.644c4.215-4.212,11.07-4.211,15.284,0c0,0,0,0,0,0c2.042,2.042,3.166,4.757,3.166,7.644 c0,2.887-1.125,5.601-3.166,7.642C100.679,99.956,97.965,101.08,95.078,101.08z M95.078,82.469c-2,0-3.999,0.761-5.521,2.282 c-1.475,1.475-2.287,3.437-2.287,5.522s0.813,4.046,2.287,5.52c1.475,1.475,3.436,2.287,5.521,2.287s4.046-0.812,5.521-2.287 c1.475-1.475,2.287-3.435,2.287-5.521s-0.812-4.047-2.287-5.522C99.077,83.229,97.077,82.469,95.078,82.469z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaught);
export default __webpack_public_path__ + "static/media/caught.9d724bddc5612e62531bd7176ba87a2f.svg";
export { ForwardRef as ReactComponent };